import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {environment} from 'environment';
import {AuthRequest} from 'shared/auth-request/auth-request';

import {HistoryEntry} from '../model/model';

@Injectable()
export class HistoryRepository {

  constructor(
    private http: HttpClient,
    private authRequest: AuthRequest,
  ) { }

  public getHistory(): Observable<Array<HistoryEntry>> {
    return this.authRequest.handleRequest(
      this.http.get<Array<HistoryEntry>>(environment.history.historyRoute, {withCredentials: true}));
  }
}
